import API_CONFIG from '../config/api';

class AutoIncrementService {
  static baseURL = `${API_CONFIG.API_BASE}/auto-increment`;

  // Get all auto increment configurations
  static async getAutoIncrements(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.moduleCode) queryParams.append('moduleCode', params.moduleCode);
      if (params.strategy) queryParams.append('strategy', params.strategy);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);

      const response = await fetch(`${this.baseURL}?${queryParams}`, {
        method: 'GET',
        headers: API_CONFIG.HEADERS
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching auto increments:', error);
      throw error;
    }
  }

  // Get auto increment by ID
  static async getAutoIncrementById(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'GET',
        headers: API_CONFIG.HEADERS
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching auto increment:', error);
      throw error;
    }
  }

  // Create auto increment configuration
  static async createAutoIncrement(data) {
    try {
      const response = await fetch(this.baseURL, {
        method: 'POST',
        headers: API_CONFIG.HEADERS,
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating auto increment:', error);
      throw error;
    }
  }

  // Update auto increment configuration
  static async updateAutoIncrement(id, data) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'PUT',
        headers: API_CONFIG.HEADERS,
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating auto increment:', error);
      throw error;
    }
  }

  // Delete auto increment configuration
  static async deleteAutoIncrement(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'DELETE',
        headers: API_CONFIG.HEADERS
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting auto increment:', error);
      throw error;
    }
  }

  // Generate next number
  static async generateNextNumber(id, category = null) {
    try {
      const response = await fetch(`${this.baseURL}/${id}/generate-next`, {
        method: 'POST',
        headers: API_CONFIG.HEADERS,
        body: JSON.stringify({ category })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error generating next number:', error);
      throw error;
    }
  }

  // Preview next number by module code (without incrementing)
  static async previewNextByModuleCode(moduleCode, category = null) {
    try {
      const queryParams = new URLSearchParams();
      if (category) queryParams.append('category', category);
      
      const response = await fetch(`${this.baseURL}/preview/${moduleCode}?${queryParams}`, {
        method: 'GET',
        headers: API_CONFIG.HEADERS
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error previewing next number:', error);
      throw error;
    }
  }

  // Generate next number by module code (increments the counter)
  static async generateNextByModuleCode(moduleCode, category = null) {
    try {
      const response = await fetch(`${this.baseURL}/generate/${moduleCode}`, {
        method: 'POST',
        headers: API_CONFIG.HEADERS,
        body: JSON.stringify({ category })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error generating next number:', error);
      throw error;
    }
  }
}

export default AutoIncrementService;

